import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from "@webs/components-library/theming";
import { ifDefined } from 'lit/directives/if-defined.js';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';


@customElement('webs-article')
export class Article extends LitElement {
  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    typographyStyles,
    containerStyles,
    css`

    .m-article__left {
      margin-bottom: 2rem;
    }

    .m-article__right {

    }

    .m-article__author {
        font-family: var(--font-family-alternative);
        font-size: 0.7rem;
        line-height: 1.3;
        color: var(--color-grey);
        margin: 0;
    }

    .m-article__date {
        font-family: var(--font-family-base);
        font-size: 2.2rem;
        font-weight: var(--font-weight-strong);
        line-height: 1.1;
        color: var(--color-dark-grey);
        margin: 0;
        margin-bottom: 0.4rem;
    }

    @media only screen and (min-width: 768px){
        .m-article__left {
          margin-bottom: 0;
       }
    }

    `,
  ];

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;



  @property()
  date: string;

  @property()
  author: string



  protected render(): unknown {
    return html`
    <section id="${ifDefined(this.id)}" class="m-article ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
      <div part="container" class="container">
        <webs-grid-row>
          <webs-grid-column sm="2"  class="m-article__left">
            ${this.date ? html`<p class="m-article__date">${this.date}</p>` : ''}

            <p class="m-article__author">By ${this.author}</p>
          </webs-grid-column>
          <webs-grid-column sm="10" class="m-article__right">
            <div class="rich-text-container"><slot></slot></div>
          </webs-grid-column>
        </webs-grid-row>
      </div>
    </section>
    `;
  }
}
